export const PageTitle = ({ text, className }: { text: string; className?: string }) => (
  <h1 className={`text-[#5D5D5D] text-xl md:text-3xl ${className}`}>{text}</h1>
)
